import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { adminfeesincrease } from './adminfeesincrease.service';
import { global } from '../../shared/global';
import { FeesIncrease } from '../Models/feesincrease.model';
declare var $: any;

@Component({
  selector: 'app-adminfeesincrease',
  templateUrl: './adminfeesincrease.component.html',
  styleUrls: ['./adminfeesincrease.component.css']
})
export class AdminfeesincreaseComponent implements OnInit {
  @ViewChild('feesIncreaseForm') feesIncreaseForm: NgForm;
  p: number = 1;
  responseData: any;
  feesIncreaselist: Array<any> = [];
  pageLimit = global.pageLimit;
  searchtext;
  reverseSort = false;
  dataTable: any;
  isDesc: boolean;
  column: string;
  data: FeesIncrease;
  dropDownData: any; mediums: any;
  stds: any;
  userList1: Array<any> = [];
  lastkeydown1: any = 0;
  schoolSearchResult: any;
  schoolid: any;
  years: any;
  // finalData: FeesIncreaseList;
  submitted: boolean;
  schoolname:any;

  constructor(private service: adminfeesincrease, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    this.data = new FeesIncrease();
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.data.HashCode = this.rout.snapshot.paramMap.get('ID');
      this.schoolname = "- ("+ localStorage.getItem("SchoolName") +")";
    } else {
      this.data.ID = 0;
      this.spinner.hide();
    }
    this.fillMedium();
    this.fillStd();
    this.fillAcademicYear();
    $('#userIdFirstWay').focus();
  }

  fillMedium() {
    const data = {
      HashCode: this.data.HashCode
    };
    this.service.FillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.data.MediumID = 0;
      });
  }

  fillStd() {
    const data = {
      HashCode: this.data.HashCode
    };
    this.service.FillStandard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.stds = this.dropDownData.dropdownlist;
        this.data.CourseID = 0;
      });
  }

  fillAcademicYear() {
    const data = {
      //registrationID: localStorage.getItem("userID")
    };
    this.service.fillAcademicYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.years = this.dropDownData.dropdownlist;
        this.years.splice(0, 1);
        this.years.reverse();
        this.data.AcademicYearID = this.years[0]["value"];
      });
  }
  
  clearSearch() {
    this.schoolid = null;
    $('#userIdFirstWay').val(null);
    // (<HTMLInputElement>document.getElementById('userIdFirstWay')).value = null;
    this.schoolSearchResult = null;
    this.feesIncreaselist = null;
    $('#userIdFirstWay').prop("disabled", false);
  }
  
  onSubmit() {
    this.submitted = true;
    if (this.data.CourseID == 0 || this.data.CourseID == undefined || this.data.MediumID == 0 || this.data.MediumID == undefined
      || this.data.AcademicYearID == 0 || this.data.AcademicYearID == undefined) {
      return;
    }
    if (parseFloat(this.data.FeesCollected) <= 0 || parseFloat(this.data.FeesIncrease) <= 0
      || parseFloat(this.data.FeesProposal) <= 0) {
      this.toastr.error("Amount must be greater than zero");
      return;
    }
    // this.data.SchoolID = parseInt(localStorage.getItem("userID"));
    if (this.feesIncreaseForm.valid) {
      this.spinner.show();
      var standard, medium, year;
      for (var i = 0; i < this.stds.length; i++) {
        if (this.stds[i]["value"] == this.data.CourseID) {
          standard = this.stds[i]["text"];
          break;
        }
      }
      for (var i = 0; i < this.mediums.length; i++) {
        if (this.mediums[i]["value"] == this.data.MediumID) {
          medium = this.mediums[i]["text"];
          break;
        }
      }
      for (var i = 0; i < this.years.length; i++) {
        if (this.years[i]["value"] == this.data.AcademicYearID) {
          year = this.years[i]["text"];
          break;
        }
      }
      if (this.data.ID > 0) {
        this.feesIncreaselist[this.data.ID - 1]['StandardID'] = this.data.CourseID;
        this.feesIncreaselist[this.data.ID - 1]['Standard'] = standard;
        this.feesIncreaselist[this.data.ID - 1]['MediumID'] = this.data.MediumID;
        this.feesIncreaselist[this.data.ID - 1]['Medium'] = medium;
        this.feesIncreaselist[this.data.ID - 1]['AcademicYearID'] = this.data.AcademicYearID;
        this.feesIncreaselist[this.data.ID - 1]['AcademicYear'] = year;
        this.feesIncreaselist[this.data.ID - 1]['FeesCollected'] = this.data.FeesCollected;
        this.feesIncreaselist[this.data.ID - 1]['FeesIncrease'] = this.data.FeesIncrease;
        this.feesIncreaselist[this.data.ID - 1]['FeesProposal'] = this.data.FeesProposal;
        this.spinner.hide();
        this.toastr.success("Update successfully");
      }
      else {
        if (this.feesIncreaselist != undefined && this.feesIncreaselist.length == 0) {
          this.feesIncreaselist.push({
            'SrNo': 0,
            'StandardID': this.data.CourseID, 'Standard': standard, 'MediumID': this.data.MediumID, 'Medium': medium, 'AcademicYearID': this.data.AcademicYearID, 'AcademicYear': year, 'FeesCollected': this.data.FeesCollected
            , 'FeesIncrease': this.data.FeesIncrease, 'FeesProposal': this.data.FeesProposal
          });
          this.spinner.hide();
          this.toastr.success("Added successfully");
        }
        else {
          for (var i = 0; i < this.feesIncreaselist.length; i++) {
            if (this.feesIncreaselist[i]["StandardID"] == this.data.CourseID && this.feesIncreaselist[i]["MediumID"] == this.data.MediumID
              && this.feesIncreaselist[i]["AcademicYearID"] == this.data.AcademicYearID) {
              this.toastr.error("Request is already added for this course and medium and academic year");
              this.spinner.hide();
              return;
            }
          }
          this.feesIncreaselist.push({
            'SrNo': this.feesIncreaselist.length,
            'StandardID': this.data.CourseID, 'Standard': standard, 'MediumID': this.data.MediumID, 'Medium': medium, 'AcademicYearID': this.data.AcademicYearID, 'AcademicYear': year, 'FeesCollected': this.data.FeesCollected
            , 'FeesIncrease': this.data.FeesIncrease, 'FeesProposal': this.data.FeesProposal
          });
          this.spinner.hide();
          this.toastr.success("Added successfully");
        }
      }
      //this.feesIncreaseForm.resetForm();
      this.resetForm();
    }
  }
  resetForm() {
    this.data.ID = 0;
    this.data.HashCode = null;
    this.data.MediumID = 0;
    this.data.CourseID = 0;
    this.data.AcademicYearID = parseInt(this.years[0]["value"]);
    this.data.FeesCollected = null;
    this.data.FeesIncrease = null;
    this.data.FeesProposal = null;
    this.submitted = false;
  }
  editFeesIncrease(id) {
    this.data.ID = id + 1;
    this.data.CourseID = parseInt(this.feesIncreaselist[id]["StandardID"]);
    this.data.MediumID = parseInt(this.feesIncreaselist[id]["MediumID"]);
    this.data.AcademicYearID = this.feesIncreaselist[id]["AcademicYearID"];
    this.data.FeesCollected = this.feesIncreaselist[id]["FeesCollected"];
    this.data.FeesIncrease = this.feesIncreaselist[id]["FeesIncrease"];
    this.data.FeesProposal = this.feesIncreaselist[id]["FeesProposal"];
  }
  deleteFeesIncrease(id) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      this.feesIncreaselist.splice(id, 1);
    }
  }
  addNewRequest() {
    if (this.feesIncreaselist.length == 0) {
      this.toastr.error("Add New Request Detail");
      return;
    }
    this.spinner.show();
    this.data.feesIncreaseList = this.feesIncreaselist;
    this.data.Remark = $('#txtRemark').val();
    // this.finalData.SchoolID = parseInt(localStorage.getItem("userID"));
    this.service.saveFeesIncrease(this.data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.toastr.success(this.responseData.message);
          this.resetForm();
          this.router.navigate(['/registrationlist']);
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  onlyDouble(evt, val) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    if (charCode == 46 && val != undefined && String(val).includes('.'))
      return false;
    var i = String(val).indexOf('.');
    if (i > 0 && String(val).length > i + 2)
      return false
    return true;
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.feesIncreaselist.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  resetRequest() {
    this.resetForm();
    this.feesIncreaselist = [];
  }
  cancelRequest() {
    this.router.navigate(['/registrationlist']);
  }
}
